/* unplugin-vue-components disabled */import { render } from "./model.vue?vue&type=template&id=4e129567&scoped=true"
import script from "./model.vue?vue&type=script&lang=js"
export * from "./model.vue?vue&type=script&lang=js"

import "./model.vue?vue&type=style&index=0&id=4e129567&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e129567"]])

export default __exports__